import { DashboardReduxWidget } from '../../redux/types';
import { GridStackWidget } from 'gridstack';

export class GridStackHelper {
  public static transformWidgetConfigToGridConfig(widget: DashboardReduxWidget): GridStackWidget {
    return {
      id: widget.id,
      x: widget.activeLayout?.position?.x,
      y: widget.activeLayout?.position?.y,
      h: widget.activeLayout?.size.height || widget.config.defaultSize.height,
      w: widget.activeLayout?.size.width || widget.config.defaultSize.width,
      minW: widget.config.minSize?.width,
      minH: widget.config.minSize?.height,
      maxW: widget.config.maxSize?.width,
      maxH: widget.config.maxSize?.height,
      noResize: !widget.config.resizable,
      noMove: !widget.config.movable,
      locked: widget.config.locked,
    };
  }

  public static getPositionAndSizeFromGridStackWidget(widget: GridStackWidget) {
    return {
      position: {
        x: widget.x,
        y: widget.y,
      },
      size: {
        width: widget.w,
        height: widget.h,
      },
    };
  }
}
